<template>
    <div>
        <div class="content-box mr60">
            <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item :style="{marginBottom: '4px'}">
                    <span :style="{fontSize: '12px'}">撤回后工单无效，可以在“工单管理-已撤回”中找到</span>
                </el-form-item>
                <el-form-item label="撤回：" prop="delete_reason">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请输入撤销的原因，20字之内" v-model.trim="formItem.delete_reason" clearable maxlength="20" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<!-- 工单管理 待指派 撤回弹框-->
<script>
    import {find} from "lodash";
    import matomoFun from "@/utils/matomo.js";
    import API from "@/api/workOrder/material.js"
    export default {
        name: "withdrawModal",
        props:['cbs', 'id', 'tagsActive'],
        data(){
            return {
                tags: [
                    {
                        value: '1',
                        label: '待指派'
                    }, {
                        value: '2',
                        label: '制作中'
                    }, {
                        value: '3',
                        label: '被驳回'
                    }, {
                        value: '4',
                        label: '已完成'
                    }, {
                        value: '5',
                        label: '已撤回'
                    }
                ],
                formLoading:false,
                formItem:{
                    delete_reason:'',
                },
                rules:{
                    delete_reason: [
                        { required: true, message: '请输入撤销的原因，20字之内', trigger: 'blur' },
                        { min: 1, max: 20, message: '请输入撤销的原因，20字之内', trigger: 'blur' }
                    ],
                },
            }
        },
        mounted(){
        },
        methods:{
            pushMatomo(name) {
                let cur_name = find(this.tags, item=>item.value == this.tagsActive)
                let behaviorCategory = `素材工单(工单管理-${cur_name?.label})`
                matomoFun.trackEvent(behaviorCategory, '点击', name)
            },
            submitModal(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        console.log('submit!');
                        this.fetchWorkOrderDelete(this.id)
                    } else {
                        return false;
                    }
                });
            },
            hideModal(){
                this.pushMatomo('撤回(取消)')
                this.$emit('close');
            },
            //撤回
            fetchWorkOrderDelete(id) {
                this.formLoading = true
                API.postWorkOrderDelete({order_id:id,delete_reason:this.formItem.delete_reason}).then(res=>{
                    this.$message.success(res.info)
                    this.cbs.onSubmit()
                    this.formLoading = false
                },err=>{
                    this.$message.error(err.info)
                }).finally(()=>{
                    this.formLoading = false
                })
            },
        }
    }
</script>

<style scoped>

</style>
